import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en';
import fi from './fi';

const detection = {
	// order and from where user language should be detected
	order: ['path'],

	// keys or params to lookup language from
	lookupQuerystring: 'lng',
	lookupCookie: 'i18next',
	lookupLocalStorage: 'i18nextLng',
	lookupFromPathIndex: 0,
	lookupFromSubdomainIndex: 0,

	// cache user language on
	caches: ['localStorage', 'cookie'],
};

i18n
	.use(LanguageDetector)
	.init({
		detection,
		resources: {
			en: {
				translations: en
			},
			fi: {
				translations: fi
			},
		},
		fallbackLng: 'fi',

		ns: ['translations'],
		defaultNS: 'translations',

		keySeparator: false,

		interpolation: {
			escapeValue: false,
			formatSeparator: ','
		},

		react: {
			wait: true
		}
	});

export default i18n;
